import { hasUserInput } from './hasUserInput';
import { PhotoVariableInput, ProcessedPhotoInput } from './PhotoVariableInput';

export const canDisplayImage = (input: PhotoVariableInput): input is ProcessedPhotoInput =>
    hasUserInput(input) && input.processed && input.status !== 'error';